<template>
  <section v-if="loading || lessonDescription || packageDescription" class="training-info" aria-label="Ders ve paket bilgilerim" :aria-busy="loading">
    <header class="training-heading">
      <h2>Ders ve paket bilgilerim</h2>
      <p>Öğrenme planının detayları.</p>
    </header>
    <div v-if="loading" class="training-loading" role="status">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      Bilgilerin yükleniyor…
    </div>
    <div v-else class="training-items">
      <article v-if="lessonDescription" class="training-item">
        <div class="training-visual"><slot name="lesson-image"><i class="bi bi-journal-text" aria-hidden="true"></i></slot></div>
        <div class="training-copy">
          <span class="training-label">DERSİM</span>
          <h3>{{ lessonDescription.title }}</h3>
          <p v-if="lessonDescription.description">{{ lessonDescription.description }}</p>
        </div>
        <router-link v-if="lessonDescription.reviewButtonVisible && LessonUrl" :to="'/courses/' + LessonUrl" class="training-action">Derse göz at <i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
      </article>
      <article v-if="packageDescription" class="training-item">
        <div class="training-visual"><slot name="package-image"><i class="bi bi-box-seam" aria-hidden="true"></i></slot></div>
        <div class="training-copy">
          <span class="training-label">EĞİTİM PAKETİM</span>
          <h3>{{ packageDescription.title }}</h3>
          <p v-if="packageDescription.description">{{ packageDescription.description }}</p>
        </div>
        <router-link v-if="packageDescription.reviewButtonVisible" to="/training" class="training-action">Paket detayları <i class="bi bi-arrow-right" aria-hidden="true"></i></router-link>
      </article>
    </div>
  </section>
</template>
<script>
  import { mapActions } from "vuex";
  import{CleanUrl} from '@/common/url-helper';
  //import { ErrorToast} from "@/common/notification.js";
  export default {
    name: "TrainingInfo",
    props: {
    },
    data() {
      return {
        loading:false,
        packageDescription:'',
        lessonDescription:'',
        bookName:'',
        bookId:''
      }
    },
    computed: {
      LessonUrl(){
        if(this.bookId!=null && this.bookName!=null && this.bookId!='' &&  this.bookName!=''){
          return CleanUrl(this.bookName)+'/'+this.bookId;
        }
        return null;
      },
      isDemoCreated: function() {
        return this.$store.getters.isDemoCreate;
      },
    },
    methods: {
      ...mapActions(["GetTrainingFileInfo"]),
      async getTrainingFileInfo(){
        this.loading=true;
        //let toastId = LoadingToast();
        await this.GetTrainingFileInfo()
        .then((res)=>{
          this.loading=false;
          this.bookName = res.bookName;
          this.bookId = res.bookId;
          this.packageDescription = res.packageDescription;
          this.lessonDescription=res.lessonDescription;
          this.$emit("LessonTimeHandler", res.lessonTime);
          this.$emit("LessonInfoHandler", {
            studentScheduleId: res.studentScheduleId,
            scheduleStatus: res.scheduleStatus,
            lessonDateTime: res.lessonDateTime,
            canDeclareAbsence: res.canDeclareAbsence,
            isAbsenceDeclared: res.isAbsenceDeclared
          });
          this.$emit("DailyLessonBookUrl",this.LessonUrl);
          //UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
        })
        .catch(()=>{
          this.loading=false;
          //if(err.message){
          //  ErrorToast('getTrainingFileInfo' + err.message);
          //}
        });
      }
    },
    watch: {
      
    },
    mounted: function() {
      this.getTrainingFileInfo();
    }
  };
  </script>
  
  <style scoped>
  .training-info { margin-bottom: 28px; overflow: hidden; border: 1px solid #e4ece7; border-radius: 18px; background: #fff; }
  .training-heading { padding: 24px 24px 8px; }
  .training-heading h2 { margin: 0; color: #253545; font-size: 18px; font-weight: 700; letter-spacing: -.3px; }
  .training-heading p { margin: 6px 0 0; color: #637480; font-size: 13px; line-height: 1.6; }
  .training-items { padding: 0 24px; }
  .training-item { display: grid; grid-template-columns: 72px minmax(0, 1fr) auto; align-items: center; gap: 18px; padding: 22px 0; }
  .training-item + .training-item { border-top: 1px solid #eef2ef; }
  .training-visual { display: grid; place-items: center; width: 72px; height: 72px; overflow: hidden; border-radius: 14px; background: #f3f7f2; color: var(--brand-link); font-size: 26px; }
  .training-copy { min-width: 0; overflow-wrap: anywhere; }
  .training-label { display: block; margin-bottom: 6px; color: #527b6b; font-size: 10px; font-weight: 700; letter-spacing: 1px; }
  .training-copy h3 { margin: 0; color: #253545; font-size: 15px; line-height: 1.5; font-weight: 650; }
  .training-copy p { margin: 5px 0 0; color: #637480; font-size: 13px; line-height: 1.7; }
  .training-action { display: inline-flex; align-items: center; justify-content: center; gap: 10px; min-height: 40px; padding: 9px 12px; border-radius: 10px; background: #f0f7f3; color: var(--brand-link); text-decoration: none; font-size: 12px; font-weight: 600; }
  .training-action:hover { background: #e3f0e8; color: var(--brand-primary-hover); }
  .training-action:focus-visible { outline: 3px solid #cf9c30; outline-offset: 3px; }
  .training-loading { display: flex; align-items: center; gap: 10px; padding: 24px; color: #637480; font-size: 13px; }
  @media (max-width: 767px) {
    .training-heading { padding: 20px 18px 4px; }
    .training-items { padding: 0 18px; }
    .training-item { grid-template-columns: 60px minmax(0, 1fr); gap: 12px 16px; padding: 20px 0; }
    .training-visual { width: 60px; height: 60px; align-self: start; }
    .training-action { grid-column: 2; justify-self: start; }
  }
  </style>
